"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SzTypographie = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
exports.SzTypographie = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'text' : _b, _c = _a.weight, weight = _c === void 0 ? 'regular' : _c, color = _a.color, align = _a.align, className = _a.className, children = _a.children, tag = _a.tag;
    var brandColors = ['primary', 'dark', 'light'];
    var defaultColor = brandColors.includes(color) ? 'text-primary-' : 'text-';
    var colorClassname = defaultColor + (color === 'primary' ? 'brand' : color);
    var alignClassname = "text-" + align;
    var textClasses = classnames_1.default({
        big: variant === 'huge',
        large: variant === 'large',
        'd-block': variant === 'button',
        'd-block small': variant === 'caption',
        'font-family-bold': weight === 'bold',
        'font-family-medium': weight === 'medium',
        'font-family-regular': weight === 'regular',
        'font-family-light': weight === 'light'
    }, align && alignClassname, color && colorClassname, className);
    var setTag = function () {
        if (tag)
            return tag;
        else
            switch (variant) {
                case 'caption':
                case 'button':
                    return 'span';
                case 'h1':
                    return 'h1';
                case 'h2':
                    return 'h2';
                case 'huge':
                case 'large':
                case 'body':
                case 'text':
                default:
                    return 'p';
            }
    };
    var Tag = setTag();
    return react_1.default.createElement(Tag, { className: textClasses }, children);
};
exports.default = exports.SzTypographie;
